import {
  FETCH_UOM_REQUEST,
  FETCH_UOM_SUCCESS,
  FETCH_UOM_FAILURE,
  ADD_UOM_REQUEST,
  ADD_UOM_SUCCESS,
  ADD_UOM_FAILURE,
  UPDATE_UOM_REQUEST,
  UPDATE_UOM_SUCCESS,
  UPDATE_UOM_FAILURE,
  DELETE_UOM_REQUEST,
  DELETE_UOM_SUCCESS,
  DELETE_UOM_FAILURE,
  SET_UOM_EDIT,
  CLEAR_UOM_EDIT,
} from '../../../types/masters/uom/uomTypes.js';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingUom: null,
};

const uomReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_UOM_REQUEST:
    case ADD_UOM_REQUEST:
    case UPDATE_UOM_REQUEST:
    case DELETE_UOM_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_UOM_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_UOM_SUCCESS:
    case UPDATE_UOM_SUCCESS:
    case DELETE_UOM_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_UOM_FAILURE:
    case ADD_UOM_FAILURE:
    case UPDATE_UOM_FAILURE:
    case DELETE_UOM_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_UOM_EDIT:
      return { ...state, editingUom: action.payload };
    case CLEAR_UOM_EDIT:
      return { ...state, editingUom: null };
    default:
      return state;
  }
};

export default uomReducer; 